export const DIEGO_ACCOUNT_ID = '11';

export const BILLING_FIELDS = {
  plan: 'cobrancas_recorrentes',
};

export const billingFeaturesForAccount = accountId => ({
  enabled: String(accountId) === DIEGO_ACCOUNT_ID,
});

export const parseBillingPlan = value => {
  if (!value) return { version: 1, charges: [] };
  try {
    const parsed = typeof value === 'string' ? JSON.parse(value) : value;
    return {
      version: 1,
      charges: Array.isArray(parsed?.charges)
        ? parsed.charges.filter(charge => charge?.id)
        : [],
    };
  } catch {
    return { version: 1, charges: [] };
  }
};

export const serializeBillingPlan = charges =>
  JSON.stringify({ version: 1, charges });
